export const getWidgetsConfig = (attribute: string) => {
  const baliseScript = document.getElementById('eliberty-widgets');
  if (baliseScript) {
    return baliseScript.getAttribute(attribute);
  }

  return null;
};
